import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=4e518376&scoped=true&"
var script = {}
import style0 from "./Telegram.vue?vue&type=style&index=0&id=4e518376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e518376",
  null
  
)

export default component.exports